<cs-header hideType="auto">
  <cs-header-title large>
    <span class="clickable-title" (click)="onTitleClick()">
      <span>{{ currentDayLabel + (fakeToday ? ' ' + fakeToday : '') }}</span>
      <cs-icon large name="arrow-point-down"></cs-icon>
    </span>
  </cs-header-title>
  <cs-icon-button header-right icon="settings" large (click)="handleSettingsButtonClicked($event)"></cs-icon-button>
  <cs-header-content>
    <cs-task-calendar [taskStatuses]="calendarTaskStatuses" [selectedDate]="currentDay"
      (selectedDateChange)="onCalendarDateSelected($event)">
    </cs-task-calendar>
    <div class="segment-container">
      <cs-segment [(selection)]="selectedTab">
        <cs-segment-button [value]="NutritionTab.Logged">
          {{ LL.nutrition.targets.logged() }}
        </cs-segment-button>
        <cs-segment-button [value]="NutritionTab.Remaining">
          {{ LL.nutrition.targets.remaining() }}
        </cs-segment-button>
      </cs-segment>
    </div>
  </cs-header-content>
</cs-header>

<!-- Template for day nutrients card -->
<ng-template #dayNutrientsCard let-displayNutrients="displayNutrients" let-matchPc="matchPc">
  @if (displayNutrients && displayNutrients.length > 0) {
    <cs-card class="day-info">
      <cs-card-title>
        {{ selectedTab === NutritionTab.Logged ? LL.nutrition.macrosLogged() : LL.nutrition.macrosRemaining() }}
      </cs-card-title>
      <cs-card-content>
        <div class="macro-targets-content">
          <nutrient-list [nutrients]="displayNutrients" state="linear-card" [expandable]="true"
            [displayMode]="selectedTab === NutritionTab.Logged ? NutrientDisplayMode.Logged : NutrientDisplayMode.Remaining"
            [match_pc]="matchPc">
          </nutrient-list>
          @if (userDb.macrosFlexible || userDb.calorieCycling) {
            <cs-text-alert type="info">
              @if (userDb.macrosFlexible) {
                <help-link helpId="@help:nutrition.flexible">{{ LL.nutrition.flexibleNutritionLink() }}</help-link>
              }
              @if (userDb.macrosFlexible && userDb.calorieCycling) {
                {{ LL.common.words.and() }}
              }
              @if (userDb.calorieCycling) {
                <help-link helpId="@help:intake.advanced-training-techniques-calorie-cycling">{{ LL.nutrition.calorieCyclingLink() }}</help-link>
              }
              {{ userDb.macrosFlexible && userDb.calorieCycling ? LL.nutrition.enabledForMealsBoth() : LL.nutrition.enabledForMeals() }}
            </cs-text-alert>
          }
        </div>
      </cs-card-content>
    </cs-card>
  }
</ng-template>

<!-- The only route to the Meal Planner from the day view itself (#4972). Before
     this, the planner was reachable only from the settings menu, and almost
     nobody found it. It is deliberately a plain outlined button under the
     meals, not a card or a highlighted call to action: planning a week is a
     weekly job, so it must not draw more attention than the daily meals.

     Rendered into both day slots, because the page keeps two copies of the day
     and cross-fades between them on every day change — a button in only one
     slot would vanish on every second change. Hidden while that slot is still
     loading, so a spinner is never shown with a lone button under it. -->
<ng-template #planMyWeekButton let-loading="loading">
  @if (!loading) {
    <div class="plan-week-action">
      <cs-button secondary medium (click)="openMealPlanner()">
        {{ LL.nutrition.planMyWeek() }}
      </cs-button>
    </div>
  }
</ng-template>

<cs-tab-content-container [selection]="activeDaySlot" [animate]="animateDayContent" [isBack]="isBack"
  [swipeEnabled]="hasClientSmallScreen()" (swipeForward)="handleSwipeForward()" (swipeBack)="handleSwipeBack()">
  <!-- Day Content Slot A -->
  <cs-tab-content [value]="'A'" [rebuildLayerOnEnter]="true">
    <cs-content>
      @if (!slots.A.loading) {
        <cs-card-list>
          <ng-container
          *ngTemplateOutlet="dayNutrientsCard; context: { displayNutrients: slots.A.displayNutrients, matchPc: slots.A.match_pc }"></ng-container>
        </cs-card-list>
      }
      <cs-day-items #dayItemsA [loading]="slots.A.loading" [auto-expand]="false" [use-linear-nutrients]="true"
        [skip-animation]="activeDaySlot !== 'A'"
        [display-mode]="selectedTab === NutritionTab.Remaining ? NutrientDisplayMode.Remaining : NutrientDisplayMode.Logged">
        <cs-card-list-row>
          <div class="meals-header">{{ LL.nutrition.settings.meals() }}</div>
        </cs-card-list-row>
      </cs-day-items>
      <ng-container *ngTemplateOutlet="planMyWeekButton; context: { loading: slots.A.loading }"></ng-container>
    </cs-content>
  </cs-tab-content>

  <!-- Day Content Slot B -->
  <cs-tab-content [value]="'B'" [rebuildLayerOnEnter]="true">
    <cs-content>
      @if (!slots.B.loading) {
        <cs-card-list>
          <ng-container
          *ngTemplateOutlet="dayNutrientsCard; context: { displayNutrients: slots.B.displayNutrients, matchPc: slots.B.match_pc }"></ng-container>
        </cs-card-list>
      }
      <cs-day-items #dayItemsB [loading]="slots.B.loading" [auto-expand]="false" [use-linear-nutrients]="true"
        [skip-animation]="activeDaySlot !== 'B'"
        [display-mode]="selectedTab === NutritionTab.Remaining ? NutrientDisplayMode.Remaining : NutrientDisplayMode.Logged">
        <cs-card-list-row>
          <div class="meals-header">{{ LL.nutrition.settings.meals() }}</div>
        </cs-card-list-row>
      </cs-day-items>
      <ng-container *ngTemplateOutlet="planMyWeekButton; context: { loading: slots.B.loading }"></ng-container>
    </cs-content>
  </cs-tab-content>
</cs-tab-content-container>